import {
  CHK_LOGIN_SUCCESS,
  CHK_LOGIN_FAILED,
  CHK_ACCOUNT_LOCKED,
  CHK_NETWORK_ERROR,
  CHK_LOGIN_LOADING,
  CHK_RESET_LOGIN,
  CHK_INVALID_CREDENTIALS
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  isError: false,
  isLocked: false,
  isInvalidCred: false,
  data: {},
  description: ""
};

export default (state = initialState, action) => {
  switch (action.type) {

    case CHK_LOGIN_LOADING:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        isError: false,
        isLocked: false,
        isInvalidCred: false,
        data: {},
        description: ""
      };

    case CHK_LOGIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        isError: false,
        isLocked: false,
        isInvalidCred: false,
        data: action.payload,
        description: "Logged in Successfully"
      };

    case CHK_LOGIN_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        isError: false,
        isLocked: false,
        isInvalidCred: false,
        data: action.payload,
        description: "Login Failed"
      };

    case CHK_ACCOUNT_LOCKED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        isError: false,
        isLocked: true,
        isInvalidCred: false,
        data: action.payload,
        description: "Your account has been locked"
      };

    case CHK_INVALID_CREDENTIALS:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        isError: false,
        isLocked: false,
        isInvalidCred: true,
        data: action.payload,
        description: "Invalid username or password"
      };

    case CHK_NETWORK_ERROR:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        isError: true,
        isLocked: false,
        isInvalidCred: false,
        data: action.payload,
        description: "Cannot connect to the server !"
      };

    case CHK_RESET_LOGIN:
      return (state = initialState);

    default:
      return state;
  }
};
